import { useEffect } from 'react';
import { useFormikContext } from 'formik';

export function ScrollToErrorFormik(): null {
  const { isSubmitting, isValidating, errors } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValidating) {
      const errorField = Object.keys(errors)[0];
      const inputElement = document.querySelector(
        `[name="${errorField}"]`
      ) as HTMLElement | null;

      if (inputElement) {
        inputElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        inputElement.focus();
      }
    }
  }, [isSubmitting, isValidating, errors]);

  return null;
}
